// Returns parent qr type, eg. 'survey' for both 'survey' and 'feedback' qr types
export const getQrDataFieldType = (type) => {
    switch (type) {
        case 'connect':
            return 'connect';
        case 'link':
        case 'menu-link':
            return 'link';
        case 'youtube':
        case 'linkedin':
        case 'tiktok':
        case 'google-review':
        case 'review-link':
        case 'location':
        case 'liquid_link':
            return type;
        case 'review':
        case 'survey':
        case 'contact-form':
            return 'survey';
        case 'tracker':
        case 'workout-log':
        case 'service-log':
        case 'vehicle-log':
        case 'maintenance-tracker':
        case 'liquid-label':
        case 'liquid-poster':
        case 'for-sale':
        case 'garden-label':
            return 'tracker';
        case 'microsite':
        case 'landing-page':
            return 'microsite';
        case 'pdf':
        case 'menu-pdf':
        case 'menu':
        case 'user-manual':
        case 'brochure':
            return 'pdf';
        case 'bitsignal':
        case 'dbc':
            return 'dbc';
        case 'assets':
        case 'container-label':
        case 'inventory':
            return 'asset';
    };
};
